import { FileCheck2, Scale, ShieldCheck } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import content from "../../data/content.json";

const { security } = content.home;
const ICONS: Record<string, LucideIcon> = { lgpd: ShieldCheck, fundamentacao: Scale, comprovantes: FileCheck2 };
const PILLARS = security.pillars.map((p) => ({ ...p, icon: ICONS[p.id] ?? ShieldCheck }));

export function Security() {
  return (
    <section id="seguranca" data-testid="home-security" className="scroll-mt-28">
      <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 sm:py-24 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-emerald-500">{security.eyebrow}</p>
            <h2 className="mt-3 text-2xl font-semibold tracking-tight text-slate-100 sm:text-3xl">{security.heading}</h2>
          </div>
          <div className="grid gap-px overflow-hidden rounded-md border border-slate-800 bg-slate-800 lg:col-span-8">
            {PILLARS.map(({ id, icon: Icon, title, text }) => (
              <div key={id} data-testid={`security-pillar-${id}`} className="flex gap-5 bg-slate-900 p-6 sm:p-8">
                <Icon aria-hidden="true" className="h-6 w-6 shrink-0 text-emerald-500" />
                <div>
                  <h3 className="font-semibold text-slate-100">{title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-300">{text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
